function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
export {
  ownerDocument as default
};
//# sourceMappingURL=ownerDocument.es.js.map
